import "core-js/modules/es.array.concat.js";
function getAssetViewerUrl(assetId, parentId) {
  if (parentId) {
    return "/playlists/".concat(parentId, "?asset=").concat(assetId);
  }
  return "".concat(window.location.pathname, "?asset=").concat(assetId);
}
function getHubContentLink(_ref) {
  var id = _ref.id,
    type = _ref.type,
    parentId = _ref.parentId;
  if (type === 'playlist') {
    return "/playlists/".concat(id);
  }
  if (type === 'topic') {
    return "/browse/".concat(id);
  }
  return getAssetViewerUrl(id, parentId);
}
export default getHubContentLink;